export const trackPage = ({ title, ...other }) => {
  if (process.env.NODE_ENV === "production") {
    window.dataLayer.push({
      event: "page_view",
      page_title: title,
      user_id: window.user_id,
      ...other,
    })
  }
}

export const handleTrackSearch = ({ origin, destination }) => {
  window.dataLayer.push({
    event: "route_search",
    origin: origin.name,
    destination: destination.name,
    user_id: window.user_id,
  })
}

export const handleTrackAirlineButton = ({ airline_name }) => {
  window.dataLayer.push({
    event: "button_redirect",
    airline_name,
    button_name: "Book",
    section_name: "How to Book?",
    user_id: window.user_id,
  })
}

export const trackSubscription = ({ value, currency }) => {
  window.dataLayer.push({
    event: "conversion",
    send_to: "AW-16554052397/quhlCMqvqrEaEK2Wy9U9",
    value,
    currency,
    user_id: window.user_id,
  })
}
